import { useState } from 'react';
import { useTheme } from '../context/ThemeContext';

const STORAGE_KEY = 'emailInvertInDarkMode';

export function useEmailHtmlDisplay() {
  const { isDarkMode } = useTheme();
  const [invertEmailInDark, setInvertEmailInDark] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch (_) {
      return false;
    }
  });

  const toggleEmailInvert = () => {
    setInvertEmailInDark((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
      } catch (_) {}
      return next;
    });
  };

  const emailHtmlClassName = [
    'email-body email-html-frame max-w-full w-full min-w-0 !text-[16px] !leading-relaxed',
    isDarkMode && invertEmailInDark ? 'email-html-invert' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return {
    isDarkMode,
    invertEmailInDark,
    toggleEmailInvert,
    emailHtmlClassName,
  };
}
